import { I_Data_Default_Types, I_Data_Templates, I_Data_Dcbm_Service, I_ListName } from './interface';

export const templates: I_Data_Templates = {
  naturalPersonTemplateId: '639096c0cf0298be4573747d',
  naturalPersonType: '63763de8e2261941465e5ea5',
  moralPersonTemplateId: '63909867030a1b0d3b8b9127',
  moralPersonType: '63763dee3732042c6068bda3',
  physicalEntityIdentityAct: '639756e11aa9062e0e050ea7',
  reportTemplate: '645114ac70a966740a3dd396',
  galleryTemplate: '64634ad03f8dbd54249e2131'
};

export const defaultTypes: I_Data_Default_Types = {
  folder: {
    id: '639c35a828ba4c3bde7ceb35',
    class: 'Act',
    allow_selection: true,
    dashboard_display: true,
    icon: 'folder',
    link: '/data/Act/list/',
    title: 'Dossiers',
    subtitle: `Vous permet de retrouver un dossier, d'accéder à ses signataires, aux sociétés et aux biens relatifs à ce dossier`,
    order: 3
  },
  physicalPerson: {
    id: '639aff945e5e7d76e5bc741b',
    class: 'NaturalPerson',
    allow_selection: true,
    dashboard_display: true,
    icon: 'people',
    link: '/data/NaturalPerson/list/',
    title: 'Clients et Adhérents',
    subtitle: `Vous permet de retrouver la fiche d'identité d'une personne, d'accéder à ses dossiers, ses sociétés et ses biens`,
    order: 0
  },
  moralPerson: {
    id: '639affa91f946d18cd9dc39e',
    class: 'MoralPerson',
    allow_selection: true,
    dashboard_display: true,
    icon: 'account_balance',
    link: '/data/MoralPerson/list',
    title: 'Sociétés',
    subtitle: `Vous permet de retrouver une société , d'accéder à ses dossiers, la liste de ses biens, ainsi qu'a leurs représantants`,
    order: 1
  },
  physicalEntity: {
    id: '639c32da9db7cd55f11694d0',
    class: 'PhysicalEntity',
    allow_selection: true,
    dashboard_display: true,
    icon: 'location_city',
    link: '/data/PhysicalEntity/list',
    title: 'Immeubles',
    subtitle: `Vous permet de retrouver un bien , d'accéder aux dossiers qui lui font référence, ainsi qu'a leurs propriétaires`,
    order: 2
  },
  report: { id: '645114ce2efe8a172dde89be', class: 'Report', title: 'Locaux', icon: 'folder_shared' },
  gallery: { id: '64634abd5e1afd794a95f0e0', class: 'Gallery', title: 'Galeries', icon: 'folder_shared' }
};

export const dcbmservices: I_Data_Dcbm_Service = {
  report: '6385dd1c952bc744a7601ab8'
};

export const lists: I_ListName[] = [
  {
    name: 'SubCategory',
    values: [
      { _id: '65059a59e157fa9e54000000', name: 'Personnel' },
      { _id: '65059a6a5f896841f4000000', name: 'Professionnel' }
    ]
  }
];
